/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StorageLocationVo } from './StorageLocationVo';
import {
    StorageLocationVoFromJSON,
    StorageLocationVoFromJSONTyped,
    StorageLocationVoToJSON,
    StorageLocationVoToJSONTyped,
} from './StorageLocationVo';

/**
 * 
 * @export
 * @interface AdminStockManageUserListResVo
 */
export interface AdminStockManageUserListResVo {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof AdminStockManageUserListResVo
     */
    skuCode?: string;
    /**
     * SKU主图URL
     * @type {string}
     * @memberof AdminStockManageUserListResVo
     */
    imageUrl?: string;
    /**
     * 登录商品名称
     * @type {string}
     * @memberof AdminStockManageUserListResVo
     */
    productName?: string;
    /**
     * 可用库存数量
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    availableQty?: number;
    /**
     * 冻结数量
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    freezeQty?: number;
    /**
     * 待上架数量
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    pendingShelfQty?: number;
    /**
     * 批次数
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    batchCount?: number;
    /**
     * 
     * @type {Array<StorageLocationVo>}
     * @memberof AdminStockManageUserListResVo
     */
    storageLocations?: Array<StorageLocationVo>;
    /**
     * 单价(¥)，注册 SKU 单价 sku.unit_price
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    unitPrice?: number;
    /**
     * 重量(kg)，多批次时取最新批次 goods
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    weightKg?: number;
    /**
     * 包装规格(cm)，格式：长x宽x高；多批次时取最新批次 goods
     * @type {string}
     * @memberof AdminStockManageUserListResVo
     */
    packageSpecCm?: string;
    /**
     * 单个CBM，多批次时取最新批次 goods
     * @type {number}
     * @memberof AdminStockManageUserListResVo
     */
    singleCbm?: number;
}

/**
 * Check if a given object implements the AdminStockManageUserListResVo interface.
 */
export function instanceOfAdminStockManageUserListResVo(value: object): value is AdminStockManageUserListResVo {
    return true;
}

export function AdminStockManageUserListResVoFromJSON(json: any): AdminStockManageUserListResVo {
    return AdminStockManageUserListResVoFromJSONTyped(json, false);
}

export function AdminStockManageUserListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockManageUserListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'availableQty': json['availableQty'] == null ? undefined : json['availableQty'],
        'freezeQty': json['freezeQty'] == null ? undefined : json['freezeQty'],
        'pendingShelfQty': json['pendingShelfQty'] == null ? undefined : json['pendingShelfQty'],
        'batchCount': json['batchCount'] == null ? undefined : json['batchCount'],
        'storageLocations': json['storageLocations'] == null ? undefined : ((json['storageLocations'] as Array<any>).map(StorageLocationVoFromJSON)),
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'weightKg': json['weightKg'] == null ? undefined : json['weightKg'],
        'packageSpecCm': json['packageSpecCm'] == null ? undefined : json['packageSpecCm'],
        'singleCbm': json['singleCbm'] == null ? undefined : json['singleCbm'],
    };
}

export function AdminStockManageUserListResVoToJSON(json: any): AdminStockManageUserListResVo {
    return AdminStockManageUserListResVoToJSONTyped(json, false);
}

export function AdminStockManageUserListResVoToJSONTyped(value?: AdminStockManageUserListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'imageUrl': value['imageUrl'],
        'productName': value['productName'],
        'availableQty': value['availableQty'],
        'freezeQty': value['freezeQty'],
        'pendingShelfQty': value['pendingShelfQty'],
        'batchCount': value['batchCount'],
        'storageLocations': value['storageLocations'] == null ? undefined : ((value['storageLocations'] as Array<any>).map(StorageLocationVoToJSON)),
        'unitPrice': value['unitPrice'],
        'weightKg': value['weightKg'],
        'packageSpecCm': value['packageSpecCm'],
        'singleCbm': value['singleCbm'],
    };
}

